export default "__VITE_ASSET__C9$bx9cL__"